import React from 'react';
import { Flex, Input, Label, ThemeUIStyleObject } from 'theme-ui';

import { MaxLength, MinLength, OnChangeComponentParams } from '../types';

type Props = {
  minLength: MinLength;
  maxLength: MaxLength;
  onChange: (changed: OnLengthChangeParams) => void;
};
export type OnLengthChangeParams = OnChangeComponentParams<Props>;

const styles: Record<string, ThemeUIStyleObject> = {
  label: {
    alignItems: 'center',
    marginRight: 10,
    width: 'auto',
  },
  input: {
    marginLeft: 2,
    width: '100px',
  },
};

export const LengthComponent: React.FC<Props> = ({
  minLength,
  maxLength,
  onChange,
}) => (
  <Flex px={3} mt={3}>
    <Label htmlFor="min-length" sx={styles.label}>
      min
      <Input
        id="min-length"
        value={minLength}
        type="number"
        min={0}
        max={999}
        maxLength={3}
        sx={styles.input}
        onChange={event =>
          onChange({
            minLength: event.target.value,
            maxLength,
          })
        }
      />
    </Label>
    <Label htmlFor="max-length" sx={styles.label}>
      max
      <Input
        id="max-length"
        value={maxLength}
        type="number"
        min={0}
        max={999}
        maxLength={3}
        sx={styles.input}
        onChange={event =>
          onChange({
            minLength,
            maxLength: event.target.value,
          })
        }
      />
    </Label>
  </Flex>
);
